import app_de from '../lang/de/app.json';
import auth_de from '../lang/de/auth.json';
import collections_de from '../lang/de/collections.json';
import legal_de from '../lang/de/legal.json';
import misc_de from '../lang/de/misc.json';
import profile_de from '../lang/de/profile.json';
import recipes_de from '../lang/de/recipes.json';
import search_de from '../lang/de/search.json';
import app_en from '../lang/en/app.json';
import auth_en from '../lang/en/auth.json';
import collections_en from '../lang/en/collections.json';
import legal_en from '../lang/en/legal.json';
import misc_en from '../lang/en/misc.json';
import profile_en from '../lang/en/profile.json';
import recipes_en from '../lang/en/recipes.json';
import search_en from '../lang/en/search.json';

export const I18nConfig = {
    interpolation: { escapeValue: false },
    lng: 'de',
    resources: {
        de: {
            app: app_de,
            auth: auth_de,
            collections: collections_de,
            legal: legal_de,
            misc: misc_de,
            recipes: recipes_de,
            profile: profile_de,
            search: search_de
        },
        en: {
            app: app_en,
            auth: auth_en,
            collections: collections_en,
            legal: legal_en,
            misc: misc_en,
            profile: profile_en,
            recipes: recipes_en,
            search: search_en
        }
    }
};
